<div class="overlay-taslsoli">
    <div class="popup">
      <h2>اختيار قطعة الأرض</h2>
      <div class="input-field">
        <label for="baladeya"> البلدية </label>
        <!--planName-->
        <select id="baladeya" (change)="onBaladeyaNameChange($event)">
          <option value="">All</option>
          <option *ngFor="let option of baladeyaNameOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
      <!-- ============================= -->
      <div class="input-field">
        <label for="planName"> اسم المخطط </label>
        <!--planNo-->
        <select id="planName" (change)="onPlanNameChange($event)">
          <option value="">All</option>
          <option *ngFor="let option of planNameOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
      <div class="input-field">
        <label for="parcelno"> رقم القطعة </label>
        <!--planType-->
        <select id="parcelno" (change)="onParcelNoChange($event)">
          <option value="">All</option>
          <option *ngFor="let option of parcelNoOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
    </div>
  </div>
  